import React, { useEffect } from 'react';
import { useAuth } from '../../context/index';
import { getModeByUrl } from '../../util/config';
import DiscordIcon from '@images/loginScreen/discord.png';
import DiscordLoginBtnIcon from '@images/loginScreen/ic_baseline-discord.svg';

const LoginScreen = () => {
	const { login } = useAuth();

	useEffect(() => {
		if (
			getModeByUrl() === 'loginDiscord' ||
			getModeByUrl() === 'activate-login' ||
			getModeByUrl() === 'dashboard-login'
		) {
			const interval = setInterval(() => {
				const elementsByClass = document.getElementsByClassName('w3a-header__title');
				if (elementsByClass.length > 0) {
					const element = elementsByClass[0];
					element.textContent = `Connect via discord`;
					if (element.textContent) {
						clearInterval(interval);
					}
				}
			}, 100);
		} else {
			const interval = setInterval(() => {
				const elementsByClass = document.getElementsByClassName('w3a-header__title');
				if (elementsByClass.length > 0) {
					const element = elementsByClass[0];
					element.textContent = `Log In/Sign Up`;
					if (element.textContent) {
						clearInterval(interval);
					}
				}
			}, 100);
		}
	}, []);

	return (
		<div className="main">
			<div className="flex flex-col w-full sm:w-[520px] mx-8 p-[16px] gap-[16px] rounded-[32px] bg-[#F1F1F1] shadow-[0_4px_16px_0_rgba(0,0,0,0.15)]">
				<div className="flex justify-between items-center gap-[10px]">
					<p
						className="sign-in-title"
						style={{ margin: '0px' }}
					>
						Log In / Sign-up
					</p>
				</div>
				<div className="flex flex-col items-center p-[16px] w-auto bg-[#FFFFFF] rounded-[16px]">
					<div className="discord-login-icon">
						<img src={DiscordIcon.src || DiscordIcon} alt="Discord Icon" />
					</div>
					<div className="w-full m-auto text-center text-[#737373] text-[18px] leading-[28px] tracking-tighter">
						<p className="sing-in-paragraph">Welcome to FrodoBots!</p>
						<p>
							Join our Discord for LIVE support during your drives, track your progress and hang out with fellow
							FrodoBots drivers!
						</p>
					</div>
				</div>
				<div className="sign-modal-continue">
					<button
						className="continue-with-discord-btn"
						onClick={login}
					>
						<img src={DiscordLoginBtnIcon.src || DiscordLoginBtnIcon} alt="Discord Login Button Icon" />
						<p className="continue-with-discord-letter">Login</p>
					</button>
				</div>
			</div>
		</div>
	);
};

export default LoginScreen;
